import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';
import {
  Discount,
  DiscountBuyDataInterface,
  DiscountType,
  PaymentEntity,
} from 'src/app/shared';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService, HTTP_REQUESTS_TIMEOUT } from 'src/app/core';
import { PaymentService } from '../payment/services/payment.service';
import { DiscountBuyComponent } from 'src/app/shared/components/discount/discount-buy/discount-buy.component';

@Injectable({
  providedIn: 'any',
})
export class DiscountService {
  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private paymentService: PaymentService,
    private discountBuyDialog: MatDialog
  ) {}

  /**
   * Get activated discount packages for user
   * only admins
   */
  public getDiscountPackagesForUser(userId: number): Observable<Discount[]> {
    const url = this.config
      .getUrl('user.discounts')
      .replace(':id', userId.toString());

    return this.http
      .get<Discount[]>(url, { withCredentials: true })
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  /**
   * Start buying process.
   * @param id discount type id
   */
  public buy(id: number): void {
    this.generatePaymentObject(id).subscribe((payment) => {
      this.openDiscountBuyDialog({
        payment,
      });
    });
  }

  /**
   * Gets any Discount Type from server to
   * show them to user.
   */
  getTypes(): Observable<DiscountType[]> {
    const url = this.config.getUrl('discount.getTypes');
    return this.http
      .get<DiscountType[]>(url)
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  /**
   * Generates the payment object for payment.
   */
  public generatePaymentObject(
    discountTypeId: number
  ): Observable<PaymentEntity> {
    return this.paymentService.create({
      discountTypeId,
    });
  }

  /**
   * Gets any Discounts from server to
   */
  getDiscounts(): Observable<Discount[]> {
    const url = this.config.getUrl('discount.getDiscounts');
    // With credentials is necessary to inject cookies.
    return this.http
      .get<Discount[]>(url, { withCredentials: true })
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }

  /**
   * When payment is ready and generated
   * we need to open the dialog box and redirect
   * user to payment page.
   */
  public openDiscountBuyDialog(dialogData: DiscountBuyDataInterface): void {
    this.discountBuyDialog.open(DiscountBuyComponent, {
      data: dialogData,
      width: '50%',
    });
  }

  public redirectUser(url: string): void {
    window.location.href = url;
  }
}
